import { IGetMetaResponse } from 'shared/repositories/search-offers-index/v2/get-meta';

export function dataFromFetchOffersSearchMetaSelector(state: IGetMetaResponse): IGetMetaResponse['data'] {
  return state.data;
}
